import React from "react"
import PillSystemStatus from "../../../../../../gd-components/molecules/pill/pill-system-status";

export default function FieldProjectStatus_MultiselectValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-field-form-editable", "dropdown-form", "fl-wrap", "w-180", "min-h-36", props.className)} onClick={props.onClick}>
                {_.map(props.options, option => {

                    return <PillSystemStatus key         = {option.value}
                                             className   = "m-r-10 m-t-4 m-b-4"
                                             statusId    = {option.value}
                                             size        = {26}
                                             value       = {option}
                                             onClick     = {props.onClick}
                                             onDelete    = {props.onDelete}

                    />
                })}
            </div>
            {props.children}
        </React.Fragment>
    );
}
